// extracted by mini-css-extract-plugin
module.exports = {"root":"ButtonLuckyWheelLogo_root__WVyeI","wheelBody":"ButtonLuckyWheelLogo_wheelBody__YbqG1","rotate":"ButtonLuckyWheelLogo_rotate__p9Uax"};